var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page__alerts block error"},[_c('div',{staticClass:"alert alert--warning"},[_vm._v("\n        "+_vm._s(_vm.message)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./Scripts/app/profiles/components/ErrorAlert.vue